import TableControls from "@/components/table/TableControls"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import { useShipmentsStore } from "./store"
import ShipmentsTable from "./table/ShipmentsTable"

const TFSResultsDisplay: ReactiveComponent = () => {
	const store = useShipmentsStore()

	return () => {
		const result = store.getResults()
		if (result.globalTotal === 0) {
			return <p>No shipments have been created for this TFS</p>
		}
		if (result.totalItems === 0) {
			return <p>No shipments match your selected criteria.</p>
		}
		return (
			<>
				<ShipmentsTable />
				<TableControls
					entityName="Shipment Logs"
					page={store.requestOptions.page}
					pageSize={store.requestOptions.pageSize}
					totalItems={result.totalItems}
					totalPages={result.totalPages}
					setPage={(page) => (store.requestOptions.page = page)}
					setPageSize={(pageSize) => (store.requestOptions.pageSize = pageSize)}
				/>
			</>
		)
	}
}

export default defineComponent(TFSResultsDisplay)
